import React, { useState, useEffect } from 'react'
import ImportTyresPage from 'src/pages/ReportsPages/ReportsBoard/SpareParts/ImportTyresPage'
import boardReportsService from 'src/services/boardReportsService'

const ImportTyresContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [total1, setTotal1] = useState([])
  const [gTotal1, setGTotal1] = useState([])
  const [total2, setTotal2] = useState([])

  const reloadImportsTotal = async () => {
    const [query1, gQuery1, query2] = await Promise.all([
      boardReportsService.getTotalImports('13', selectedDate.getFullYear(), 'dimension=LLANTAS'),
      boardReportsService.getGTotalImports('4', selectedDate.getFullYear(), 'dimension=LLANTAS'),
      boardReportsService.getTotalImports('14', selectedDate.getFullYear(), 'dimension=LLANTAS'),
    ])
    setTotal1(query1 || [])
    setGTotal1(gQuery1 || [])
    setTotal2(query2 || [])
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadImportsTotal()
  }, [])

  return (
    <ImportTyresPage
      total1={total1}
      total2={total2}
      gTotal1={gTotal1}
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
    />
  )
}

export default ImportTyresContainer
